import map from 'lodash/map.js';

import { buildAccessDeniedLocation } from '@/utilities/accessDeniedLocation.js';

class MiddlewareRunner {
    /**
     * @param store
     * @param router
     */
    constructor(store, router) {
        this.store = store;
        this.router = router;
    }

    /**
     * Sequentially run provided middleware `fire` methods.
     * @param to
     * @param from
     * @returns {Promise<any>}
     */
    run(to, from) {
        return new Promise(resolve => {
            if (!to.meta.middleware) {
                resolve();

                return;
            }

            if (!to.meta.ability) {
                throw new Error('The middleware must provide an ability to check');
            }

            const { ability } = to.meta;

            const middleware = map(to.meta.middleware, MiddlewareStep => () => {
                return new MiddlewareStep(this.store, this.router).fire(to, from, ability);
            }).concat(() => Promise.resolve());

            middleware
                .reduce(
                    (previous, current) =>
                        previous
                            .then(() => current())
                            .catch(error => {
                                throw error;
                            }),
                    Promise.resolve(false)
                )
                .then(() => resolve())
                .catch(error => {
                    this.handleError(error, { to, from });

                    resolve();
                });
        });
    }

    /**
     * @param error
     * @param intended
     */
    handleError(error, intended) {
        const errorTypes = [error.name, error.constructor?.name].filter(Boolean);

        if (errorTypes.includes('ForbiddenError') || errorTypes.includes('GateAccessDenied')) {
            this.router.push(buildAccessDeniedLocation(intended.to, intended.from));
        }
    }
}

export default MiddlewareRunner;
